import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { withGroupOpen, withGroupToggled } from '@/lib/utils/sidebarNavHelpers';
import type { SidebarState } from '@/store/types';

export const useSidebarStore = create<SidebarState>()(
  persist(
    set => ({
      // Default to the full column: labels always on is the point of this
      // sidebar, and nothing is discoverable by hover alone on first run.
      // Persisted, so a user who collapses it stays collapsed.
      panelOpen: true,
      openGroupKeys: [],
      mobileOpen: false,
      setPanelOpen: open => set({ panelOpen: open }),
      togglePanel: () => set(s => ({ panelOpen: !s.panelOpen })),
      openGroup: key =>
        set(s => ({ openGroupKeys: withGroupOpen(s.openGroupKeys, key) })),
      openOnlyGroup: key => set({ openGroupKeys: [key] }),
      toggleGroupOpen: key =>
        set(s => ({ openGroupKeys: withGroupToggled(s.openGroupKeys, key) })),
      setMobileOpen: open => set({ mobileOpen: open }),
    }),
    {
      name: 'sidebar-store',
      partialize: s => ({
        panelOpen: s.panelOpen,
        openGroupKeys: s.openGroupKeys,
      }),
    },
  ),
);
